// client/src/components/templates/PlaceholdersPanel.js
import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { Loader2 } from 'lucide-react';

// Painel de variáveis compartilhado pelos 3 editores de template (Recibo,
// Certificado, Contrato). `placeholders` vem de um hook que busca a lista
// real do backend (ex.: useReciboPlaceholders) — nunca hardcoded aqui,
// para não divergir da lógica de substituição de cada um
// (populateReceiptTemplate/populateCertificateTemplate/populateContractTemplate).
const PlaceholdersPanel = ({ placeholders, isLoading, onInsert }) => {
    const [searchTerm, setSearchTerm] = useState('');

    const groups = useMemo(() => {
        const map = new Map();
        (placeholders || []).forEach(p => {
            const list = map.get(p.category) || [];
            list.push(p);
            map.set(p.category, list);
        });
        return Array.from(map.entries()).map(([category, items]) => ({ category, items }));
    }, [placeholders]);

    const filteredGroups = groups
        .map(group => ({
            ...group,
            items: group.items.filter(
                item =>
                    item.label.toLowerCase().includes(searchTerm.toLowerCase()) ||
                    item.value.toLowerCase().includes(searchTerm.toLowerCase())
            ),
        }))
        .filter(group => group.items.length > 0);

    return (
        <div className="editor-variables-panel">
            <div className="panel-header">
                <h5 className="panel-title">Variáveis Disponíveis</h5>
                <input
                    type="search"
                    placeholder="Buscar variável..."
                    className="variables-search-input"
                    value={searchTerm}
                    onChange={e => setSearchTerm(e.target.value)}
                />
            </div>
            {isLoading ? (
                <p className="text-muted text-center p-4"><Loader2 size={16} className="animate-spin icon" /> Carregando variáveis...</p>
            ) : filteredGroups.length > 0 ? (
                filteredGroups.map(group => (
                    <div key={group.category} className="variables-category">
                        <h6 className="variables-category-title">{group.category}</h6>
                        <div className="variables-grid">
                            {group.items.map(p => (
                                <button
                                    key={p.value}
                                    type="button"
                                    onClick={() => onInsert(p.value)}
                                    className="variable-button"
                                >
                                    <span className="variable-label">{p.label}</span>
                                    <code className="variable-code">{p.value}</code>
                                </button>
                            ))}
                        </div>
                    </div>
                ))
            ) : (
                <p className="text-muted text-center p-4">Nenhuma variável encontrada.</p>
            )}
        </div>
    );
};

PlaceholdersPanel.propTypes = {
    placeholders: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired,
        category: PropTypes.string.isRequired,
    })),
    isLoading: PropTypes.bool,
    onInsert: PropTypes.func.isRequired,
};

PlaceholdersPanel.defaultProps = {
    placeholders: [],
    isLoading: false,
};

export default PlaceholdersPanel;
